<div matDialog>
  <div class="vertically-centered" style="margin: 16px">
    <span>{{ "operations.add_note_for" | transloco }}&nbsp; </span>
    @if(data.meterings.length > 1) {
    <mat-form-field appearance="outline">
      <mat-select
        [value]="selectedMetric().id"
        (selectionChange)="handleSelectionChange($event)">
        @for(metering of data.meterings; track metering) {
        <mat-option
          [value]="metering.id"
          class="loren-chart-note-dialog-option">
          <div
            class="loren-chart-note-dialog-circle"
            [style.backgroundColor]="metering.color"></div>
          {{ metering.name }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    } @else {
    <span> {{ data.meterings[0].name }}</span>
    }
  </div>
  <mat-dialog-content>
    @if(notesShown()?.length) { @for(note of notesShown(); track note) {
    <div class="mb-2">
      <span class="font-italic"
        >{{ note?.author }} {{ "chart.at" | transloco }}
        {{ $safeNavigationMigration(note?.createdOnFormatted) | lorenDate }}:
      </span>
      {{ note?.note }}
    </div>
    } }
    <mat-form-field class="w-100 mt-4" appearance="outline">
      <mat-label>{{ "chart.note" | transloco }}</mat-label>
      <input
        matInput
        [(ngModel)]="newNote"
        id="note"
        required
        maxlength="120" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions style="margin: 16px">
    <button
            matButton="filled"
      [mat-dialog-close]="{ metering: selectedMetric().id, note: newNote }"
      [disabled]="!newNote?.trim()">
      {{ "operations.save" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
